import { graphql } from "@/graphql/codegen"

graphql(`
  mutation CreateSalesRequest($input: SalesRequestCreateInput!) {
    salesPipeline {
      createRequest(input: $input) {
        __typename
        ... on SalesRequestCreateSuccess {
          items {
            salesPipelineQuoteRequestId
            quoteGroupId
          }
        }
        ... on SalesRequestCreateFailure {
          error {
            message
          }
        }
      }
    }
  }
`)

graphql(`
  mutation SendSalesQuoteEmail($quoteGroupId: Int!, $emailReceiverContactIds: [String!]!, $emailNote: String) {
    salesPipeline {
      sendSalesQuoteEmail(
        quoteGroupId: $quoteGroupId
        emailReceiverContactIds: $emailReceiverContactIds
        emailNote: $emailNote
      ) {
        __typename
        ... on SendSalesQuoteEmailSuccess {
          sentTo
        }
        ... on SendSalesQuoteEmailFailure {
          error {
            message
          }
        }
      }
    }
  }
`)

graphql(`
  mutation DeleteDraftQuoteRequest($quoteGroupId: Int!) {
    salesPipeline {
      deleteDraftQuoteRequest(quoteGroupId: $quoteGroupId) {
        __typename
        ... on DeleteDraftQuoteRequestSuccess {
          quoteGroupId
        }
        ... on DeleteDraftQuoteRequestFailure {
          error {
            message
          }
        }
      }
    }
  }
`)
